import { useParams } from 'react-router-dom';
import { useAtomValue } from 'jotai';
import Markdown from 'markdown-to-jsx';

import { ContentWrapper, Description, Image, ImageWrapper, Name } from './index.styles';

import PageWrapper from '../../../../../../page_wrapper';
import HeaderWithButton from '../../../../header_with_button';

import useI18nText from '../../../../../../../hooks/useI18nText';

import { vendorCardOfferQuery } from '../../../../../../../store';

import type { Offer } from '@rewardopl/types';

export default function OfferPage() {
  const { offer_id: offerId } = useParams<{ offer_id?: Offer['_id'] }>();

  if (!offerId) {
    throw new Error('offerId is undefined');
  }

  const offer = useAtomValue(vendorCardOfferQuery(offerId));

  const {
    description,
    description_i18n: descriptionI18n,
    name,
    name_i18n: nameI18n,
    picture,
  } = offer;

  const nameString = useI18nText(nameI18n, name);
  const descriptionString = useI18nText(descriptionI18n, description ?? '');

  return (
    <>
      <HeaderWithButton>News</HeaderWithButton>
      <PageWrapper>
        {picture ? (
          <ImageWrapper>
            <Image alt={nameString} src={`/api/uploads/${picture}`} />
          </ImageWrapper>
        ) : null}
        <ContentWrapper>
          <Name>{nameString}</Name>
          {descriptionString ? (
            <Description>
              <Markdown>{descriptionString}</Markdown>
            </Description>
          ) : null}
        </ContentWrapper>
      </PageWrapper>
    </>
  );
}
